// extracted by mini-css-extract-plugin
export default {"root":"EditSolutionModal_root__Zfllp","container":"EditSolutionModal_container__Xo502"};